import { BasicModal } from '@app/components/ui/modals/BasicModal'
import { IDLE_DETECTOR_MODAL_ATTRIBUTES, RESET_IDLE_STATE_BTN_ATTRIBUTES } from '@app/constants'
import { useUserAssessentPauseCallback, useUserAssessentResumeCallback } from '@app/helpers'
import {
  closeIdleModal,
  IdleDetectorState,
  openIdleModal,
  resetIdleDetectorState,
  resumeSyncInterval,
  startIdleModalTimer,
} from '@app/storage'
import { FC, useEffect } from 'react'
import { useSnapshot } from 'valtio'
import { timeConverter } from '../helpers'
import { getTerm } from '@app/helpers/workkeysReplaceTerms'

const testTerm = getTerm('Test', true)

type IdleDetectorModalProps = {}

export const IdleDetectorModal: FC<IdleDetectorModalProps> = () => {
  const { isIdle, countdown, modalOpened } = useSnapshot(IdleDetectorState)
  const handlePauseAssessment = useUserAssessentPauseCallback()
  const handleResumeAssessment = useUserAssessentResumeCallback()

  useEffect(() => {
    if (isIdle) {
      openIdleModal()
    }
  }, [isIdle])

  useEffect(() => {
    if (modalOpened) {
      startIdleModalTimer()
      return
    }

    resetIdleDetectorState()
  }, [modalOpened])

  useEffect(() => {
    if (countdown === 0) {
      handlePauseAssessment()
    }
  }, [countdown, handlePauseAssessment])

  const handleResetIdle = () => {
    closeIdleModal()
    handleResumeAssessment()
    resumeSyncInterval()
    resetIdleDetectorState()
  }

  return (
    <BasicModal
      title='You are idle'
      open={modalOpened}
      onSubmit={handleResetIdle}
      submitText={`I'm still here!`}
      backdropDisabled
      noCancel
      modalProps={IDLE_DETECTOR_MODAL_ATTRIBUTES}
      submitButtonProps={RESET_IDLE_STATE_BTN_ATTRIBUTES}
    >
      {/* a11y: Use single template-literal expressions so NVDA reads each sentence as one continuous sentence — each JSX {expression} becomes its own DOM text node, which fragments screen-reader output. */}
      {countdown > 0 ? (
        <>
          <p style={{ marginBottom: 0 }}>{`${testTerm} will be paused automatically in`}</p>
          <span>{timeConverter(countdown)}</span>
        </>
      ) : (
        <p>{`${testTerm} has been paused`}</p>
      )}
    </BasicModal>
  )
}
